export function convertDimensionsToDiameter(height, width) {
    let calculatedDiameter = Math.floor(((width + height) / 2) * 1.273);
    let diameterToString = '';

    if (calculatedDiameter === 127) {
        diameterToString = '127';
    } else if (calculatedDiameter >= 128 && calculatedDiameter <= 159) {
        diameterToString = '128-159';
    } else if (calculatedDiameter >= 160 && calculatedDiameter <= 191) {
        diameterToString = '160-191';
    } else if (calculatedDiameter >= 192 && calculatedDiameter <= 223) {
        diameterToString = '192-223';
    } else if (calculatedDiameter >= 224 && calculatedDiameter <= 255) {
        diameterToString = '224-255';
    } else if (calculatedDiameter >= 256 && calculatedDiameter <= 287) {
        diameterToString = '256-287';
    } else if (calculatedDiameter >= 288 && calculatedDiameter <= 318) {
        diameterToString = '288-318';
    } else if (calculatedDiameter >= 319 && calculatedDiameter <= 350) {
        diameterToString = '319-350';
    } else if (calculatedDiameter >= 351 && calculatedDiameter <= 382) {
        diameterToString = '351-382';
    } else if (calculatedDiameter > 382) {
        diameterToString = '> 400';
    }

    return {diameter: diameterToString};
}

export function convertProductToUrl(productName) {
    return productName.replace(/ /g, '-').replace('*', '').toLowerCase();
}

export function translate(obj, key, fallBackValue = '') {
    return key.split(".").reduce(function (o, x) {
        return (typeof o == "undefined" || o === null) ? fallBackValue : o[x]
    }, obj);
}
